@if (hasAccessToAISummary()) {
  <button mat-stroked-button (click)="openAISummaryModal()">
    <mat-icon svgIcon="galaxy-ai-icon" class="aiIcon" />
    <div class="button-text">
      {{ 'AI_SUMMARY.BUTTON.TITLE' | translate }}
    </div>
  </button>
} @else if (showAISummaryRestrictedDialog()) {
  <button mat-stroked-button (click)="openRestrictedModal()" class="restricted-ai-summary">
    <mat-icon svgIcon="galaxy-ai-icon" class="aiIcon" />
    <div class="button-text">
      {{ 'AI_SUMMARY.BUTTON.TITLE' | translate }}
    </div>
  </button>
}
